import React, { createContext, useContext, useState } from "react";

const UiContext = createContext({ density: "comfortable", setDensity: () => {} });
const STORAGE_KEY = "phoenix.ui.density";

export function UiPreferences({ children }) {
  const [density, updateDensity] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "compact" ? "compact" : "comfortable"; }
    catch { return "comfortable"; }
  });
  const setDensity = (value) => {
    const next = value === "compact" ? "compact" : "comfortable";
    updateDensity(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* Appearance remains usable without storage. */ }
  };
  return <UiContext.Provider value={{ density, setDensity }}><div className="phx-ui" data-density={density}>{children}</div></UiContext.Provider>;
}

export function DensityControl() {
  const { density, setDensity } = useContext(UiContext);
  return <label className="phx-density">Row density<select data-testid="ui-density" value={density} onChange={(event) => setDensity(event.target.value)}>
    <option value="comfortable">Comfortable</option><option value="compact">Compact</option>
  </select></label>;
}
